import * as React from 'react'
function SvgOsApple(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M26.136 13.454c2.01 0 4.14 1.094 5.656 2.984-4.97 2.726-4.162 9.824.86 11.722-.692 1.532-1.022 2.216-1.914 3.57-1.242 1.89-2.992 4.246-5.162 4.266-1.928.018-2.424-1.254-5.04-1.24-2.616.014-3.164 1.262-5.092 1.244-2.17-.02-3.828-2.146-5.072-4.038C6.9 26.674 6.536 20.47 8.678 17.172c1.522-2.346 3.924-3.716 6.184-3.716 2.3 0 3.744 1.26 5.646 1.26 1.844 0 2.968-1.262 5.628-1.262zM26.826 4c.302 2.02-.526 3.998-1.618 5.398-1.17 1.5-3.182 2.662-5.128 2.602-.354-1.934.558-3.924 1.662-5.266C22.96 5.256 25.044 4.122 26.826 4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgOsApple
